import React, {Component} from 'react';
import MaterialIcon from "material-icons-react";
import strings from "../screenLocalisation/account";
import NavLink from "react-router-dom/es/NavLink";

class NotConnected extends Component {
    render() {
        return (
            <div>
                <MaterialIcon icon={'battery_charging_full'}/>
                <p>{strings.reasonDistance}</p>

                <MaterialIcon icon={'battery_alert'}/>
                <p>{strings.reasonAlerts}</p>

                <MaterialIcon icon={'timeline'}/>
                <p>{strings.reasonHistory}</p>

                <NavLink to={'/register'}>{strings.connectButton}</NavLink>
            </div>
        );
    }

}

export default NotConnected;